import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { TextBox } from 'fw/forms';
import { SetupSearch } from 'areas/shared/pages/setup';
import { StatusFilter } from 'areas/shared/controls'

class Search extends SetupSearch {

    initialForm() {
        return {
            searchText: "",
            statusFilter: true
        }
    }

    renderForm() {
        return (
            <Row>
                <Col md={4}>
                    <TextBox name="searchText" placeholder="Key name..." autoFocus />
                </Col>
                <Col md={2}>
                    <StatusFilter name="statusFilter" onChange={this.search} entity="Help pages" />
                </Col>
            </Row>
        )
    }
}

export default Search;


// WEBPACK FOOTER //
// ./src/areas/admin/helpSetup/Search.js